var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrashIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 3.7373C11.0438 3.53105 8.95 3.4248 6.8625 3.4248C5.625 3.4248 4.3875 3.4873 3.15 3.6123L1.875 3.7373",
    stroke: "url(#paint0_linear_4937_20890)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.3125 3.10625L5.45 2.2875C5.55 1.69375 5.625 1.25 6.68125 1.25H8.31875C9.375 1.25 9.45625 1.71875 9.55 2.29375L9.6875 3.10625",
    stroke: "url(#paint1_linear_4937_20890)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7813 5.7124L11.375 12.0062C11.3063 12.9874 11.25 13.7499 9.50625 13.7499H5.49375C3.75 13.7499 3.69375 12.9874 3.625 12.0062L3.21875 5.7124",
    stroke: "url(#paint2_linear_4937_20890)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.45605 10.3125H8.5373",
    stroke: "url(#paint3_linear_4937_20890)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.9375 7.8125H9.0625",
    stroke: "url(#paint4_linear_4937_20890)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4937_20890",
    x1: 7.07812,
    y1: 3.37272,
    x2: 7.0864,
    y2: 3.82303,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF765C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5349"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4937_20890",
    x1: 7.33594,
    y1: 0.940625,
    x2: 8.03233,
    y2: 3.42085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF765C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5349"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4937_20890",
    x1: 7.17891,
    y1: 4.37282,
    x2: 12.372,
    y2: 12.7328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF765C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5349"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4937_20890",
    x1: 7.41863,
    y1: 10.1458,
    x2: 7.83489,
    y2: 11.455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF765C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5349"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4937_20890",
    x1: 7.38281,
    y1: 7.64583,
    x2: 7.67497,
    y2: 9.02545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF765C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5349"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIcon);
export default __webpack_public_path__ + "static/media/trash-icon.3d7fccbf0918bce2d4daa71473adbf34.svg";
export { ForwardRef as ReactComponent };